import { useRef } from "react";
import Panel from "../Panel/Panel";
import { wrapAuthData } from "../AuthData/AuthData";
import ReadMore from "../ReadMore/ReadMore";
import ReadMoreButton from "../ReadMore/ReadMoreButton";
const shimmerProps = {height: "197px"};
const requires = ["child"];

export function ChildStory(props) {
  const { requiredData } = props;
  const { child } = requiredData;
  const panelRef = useRef();

  if (!child?.story?.length) {
    return null;
  }

  return (
    <Panel classList="panel__child-story" panelRef={panelRef}>
      <h3 className="eta">{child.givenName}'s story</h3>
      <div className="panel__child-story__text">
        <ReadMore initialHeight={100} readMoreButton={ReadMoreButton} showMobileOnly={false} parentScrollRef={panelRef}>
          { 
            child?.story?.length 
            ? child.story.map(text => <p key={text}>{text}</p>)
            : null 
          }
        </ReadMore>
      </div>
    </Panel>
  );
}

export default wrapAuthData(ChildStory, {shimmerProps, requires, name: "ChildStory"});